import React from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
	label: {
		"& .MuiFormControlLabel-label": {
			paddingBottom: "1px",
		},
	},
});

const CheckboxComponent = ({ label, id, checked, onChange, disabled }) => {
	const classes = useStyles();

	return (
		<FormControlLabel
			className={`my-auto p-0 ${classes.label}`}
			control={
				<Checkbox
					id={id}
					checked={checked}
					onChange={onChange}
					name={id}
					color="primary"
					disabled={disabled}
				/>
			}
			label={label}
			disabled={disabled}
		/>
	);
};

export default CheckboxComponent;
